import { ReactElement, useContext } from "react";
import RadarChart from "../../../components/charts/radarChart";
import { IRadarChartConfig } from "../../../components/charts/types";
import { ReportContext } from "./productionReportContext";

export interface IProps {
  radarConfig: IRadarChartConfig;
}

const RadarContainer = ({ radarConfig }: IProps): ReactElement => {
  const reportContext = useContext(ReportContext);

  return <RadarChart radarConfig={radarConfig} selectedItem={reportContext.selected.productionID}/>;
};


export default RadarContainer;
